import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyCn2PikIaYaZhMCm84QJYwBnggYH8V_NII",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "crm.naaz.marketing",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "spark-crm-5d8c7",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "spark-crm-5d8c7.firebasestorage.app",
  messagingSenderId: "43422621246",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:43422621246:web:unknown",
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL || "https://spark-crm-5d8c7.firebaseio.com"
};

let app;
try {
  app = initializeApp(firebaseConfig);
  console.log("Firebase Initialized Successfully");
} catch (e) {
  console.error("Firebase Initialization Failed:", e);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
// Explicit development-only emulator mode cannot redirect a production build.
if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_EMULATOR === 'true') {
  if (!firebaseConfig.projectId.startsWith('demo-')) throw new Error('Emulator mode requires a demo project');
  connectAuthEmulator(auth, 'http://127.0.0.1:19099');
  connectFirestoreEmulator(db, '127.0.0.1', 18080);
}
export default app;
